"use client"
import styles from "./InfoCard.module.css"

const InfoCard = ({ title, data, className = "" }) => {
  return (
    <div className={`${styles.info_card} ${className}`}>
      {title && <h4 className={styles.info_card_title}>{title}</h4>}
      <div className={styles.info_card_grid}>
        {data.map((item, index) => (
          <div key={index} className={styles.info_card_item}>
            <span className={styles.info_card_label}>{item.label}</span>
            <span className={styles.info_card_value}>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default InfoCard